import { classNames as joinClassNames } from "primereact/utils";

import styles from "./empty-state.module.scss";
import type { EmptyStateViewProps } from "./types-empty-state";

export function EmptyStateView({
  className,
  style,
  size,
  testId,
  rest,
  children,
}: EmptyStateViewProps) {
  return (
    <div
      className={joinClassNames(styles.root, className)}
      style={style}
      role="status"
      data-size={size}
      data-testid={testId}
      {...rest}
    >
      {children}
    </div>
  );
}
